const userInfo = {
  namespaced: true,
  state: {
    user: {
      name: '',
      account: '',
      telPhone: '',
      email: '',
      description: '',
      defaultUrl: '',
      //是否已其他账号进去
      runAsOther: false,
      //已其他账号进去之后返回的账号（原本的账号）
      backAccount: '',
      isAdmin: false,
      avatar: '',
      entryListMap: {},
      authorized: [],
      btnPermissions: {},
      menuPermissions: [],
      userTheme: '',
      systemRoles: [],
      telePhone: ''
    }
  },
  getters: {
    user: state => state.user,
    name: state => state.user?.name,
    account: state => state.user?.account || 'guest',
    accountType: state => state.user.accountType,
    backAccount: state => state.user?.backAccount,
    avatar: state => state.user?.avatar,
    isAdmin: state => state.user?.isAdmin,
    entryListMap: state => state.user?.entryListMap,
    runAsOther: state => state.user?.runAsOther,
    authorized: state => state.user?.authorized,
    btnPermissions: state => state.user?.btnPermissions,
    menuPermissions: state => state.user?.menuPermissions,
    userTheme: state => state.user?.userTheme,
    systemRoles: state => state.user?.systemRoles,
    telePhone: state => state.user?.telePhone,
  },
  mutations: {
    SET_USER (state, payload) {
      state.user = payload
    },
    SET_USER_PARAMTER (state, payload) {
      // 直接异常抛掉
      if (payload.key == undefined || payload.key == null) throw Error("please check data key!")
      state.user[payload.key] = payload.value
    },
  },
  actions: {
    // 登录操作
    async updateUserInfo (context, data) {
      // 触发mutation，存储data
      context.commit("SET_USER", data)
    },
    async updateUserInfoParams (context, data) {
      // 触发mutation，存储data
      if (data instanceof Array) {
        data.forEach(item => {
          context.commit("SET_USER_PARAMTER", item)
        })
      } else {
        context.commit("SET_USER_PARAMTER", data)
      }
    },
  }
}

export default userInfo
